const width = window.innerWidth

export const isSmallPhone = width <= 320

export const setSize = (normal, small) => (isSmallPhone ? small : normal)

export const FONT_WEIGHTS = {
    medium: 500,
    semibold: 600,
    bold: 700,
}

const { medium, bold, semibold } = FONT_WEIGHTS

const fonts = {
    G: {
        fontWeight: semibold,
        fontSize: setSize(80, 50),
        lineHeight: setSize(80, 50),
    },
    XXXXL: {
        fontWeight: semibold,
        fontSize: setSize(46, 30),
        lineHeight: setSize(54, 35),
    },
    XXXL: {
        fontWeight: semibold,
        fontSize: setSize(30, 24),
        lineHeight: setSize(35, 30),
    },
    XXL: {
        fontWeight: bold,
        fontSize: setSize(24, 20),
        lineHeight: setSize(30, 24),
    },
    XL: {
        fontWeight: semibold,
        fontSize: setSize(20, 16),
        lineHeight: setSize(24, 22),
    },
    L: {
        fontWeight: semibold,
        fontSize: setSize(18, 15),
        lineHeight: setSize(22, 20),
    },
    M: {
        fontWeight: semibold,
        fontSize: setSize(16, 13),
        lineHeight: setSize(20, 18),
    },
    S: {
        fontWeight: medium,
        fontSize: setSize(14, 12),
        lineHeight: setSize(18, 15),
    },
    XS: {
        fontWeight: semibold,
        fontSize: setSize(12, 10),
        lineHeight: setSize(15, 14),
    },
    XXS: {
        fontWeight: semibold,
        fontSize: setSize(11, 9),
        lineHeight: setSize(14, 12),
    },
    XXXS: {
        fontWeight: semibold,
        fontSize: setSize(10, 8),
        lineHeight: setSize(12, 10),
    },
    T: { // for tiny
        fontWeight: semibold,
        fontSize: setSize(8, 6),
        lineHeight: setSize(10, 8),
    },
}

// Add font family and attach 'px' to pixel units
Object.keys(fonts).forEach((size) => {
    fonts[size].fontFamily = 'Montserrat'
    fonts[size].fontSize += 'px'
    fonts[size].lineHeight += 'px'
})

export default fonts
